import React, { useContext } from "react";
import styled from "styled-components";
import { themeProp } from "../../../theme";
import Heading from "../../../components/Heading";
import { useString as s } from "../../../components/StringProvider";
import { CostOfStatusQuoChart } from "../../ValueHypothesis/components";
import { Text } from "../../../components";
import PropType from "prop-types";
import CostOfStatusQuoChartProvider, {
  CostOfStatusQuoChartContext,
  CostOfStatusQuoChartModes
} from "../../ValueHypothesis/components/CostOfStatusQuoChartProvider";
import ValueHypothesisProvider from "../../ValueHypothesis/components/ValueHypothesisProvider";

const PrintReportValueHypothesisTwo = ({ kpis, currency }) => {
  const { chartMode } = useContext(CostOfStatusQuoChartContext);
  const costOfStatusQuoChartHeader = s(
    "discovery.opportunity.page.header2",
    "Cost of Status Quo"
  );
  const costOfStatusQuoChartSubheader = s(
    "discovery.opportunity.page.subheader2",
    "The cost to you if you choose not to use the {companyName} platform"
  );
  const benefitSummaryChartHeader = s(
    "discovery.opportunity.page.benefitSummaryChart.header",
    "Benefit Summary"
  );
  const benefitSummaryChartSubheader = s(
    "discovery.opportunity.page.benefitSummaryChart.subheader",
    "The annual benefits to be gained after adopting the new solution"
  );

  return (
    <ContainerContainer>
      <Container>
        <Heading level={"h1"} align={"center"}>
          {chartMode === CostOfStatusQuoChartModes.COST_OF_STATUS_QUO
            ? costOfStatusQuoChartHeader
            : benefitSummaryChartHeader}
        </Heading>
        <Text alignment={"center"} style={{ marginBottom: 20 }}>
          {chartMode === CostOfStatusQuoChartModes.COST_OF_STATUS_QUO
            ? costOfStatusQuoChartSubheader
            : benefitSummaryChartSubheader}
        </Text>
        <ValueHypothesisProvider reportMode={true}>
          <CostOfStatusQuoChartProvider>
            <CostOfStatusQuoChart
              kpis={kpis}
              currency={currency}
              reportMode={true}
              printMode={true}
            />
          </CostOfStatusQuoChartProvider>
        </ValueHypothesisProvider>
      </Container>
    </ContainerContainer>
  );
};

const ContainerContainer = styled.div`
  background-color: ${themeProp("palette.surface")};
`;

const Container = styled.div`
  background-color: ${themeProp("palette.background")};
  min-height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  padding: 0 40px 80px 40px;
  margin-top: 80px;
`;

PrintReportValueHypothesisTwo.propTypes = {
  currency: PropType.string.isRequired,
  kpis: PropType.array.isRequired
};

export default PrintReportValueHypothesisTwo;
